import * as React from "react";
import { forwardRef } from "react";
const SvgMobileWave = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 375, height: 300, fill: "none", viewBox: "0 0 375 300", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M214.786 43.092C140.187-1.592 43.558-5.654 0 4.792V300h375V32.937C348.965 62.533 255.185 67.29 214.786 43.092", className: "filler" }));
const ForwardRef = forwardRef(SvgMobileWave);
export default ForwardRef;
